export const ImportDataHeader = [
  {
    label: "Shipto",
    key: "customer_account_number",
  },
 
  {
    label: "Deactivation Date(MM-DD-YYYY)",
    key: "signature_end_date",
  }
  
];
export const exporDatatHeaders = [
  {
    label: "Member ID",
    key: "loyalty_id",
  },
  {
    label: "Shipto",
    key: "customer_account_number",
  },
  {
    label: "Billto",
    key: "customer_billto_account_number",
  },
  {
    label: "Shipto Name",
    key: "customer_name",
  },
  {
    label: "Signature Status",
    key: "signature_flag",
  },
  
  {
    label: "Payment Plan",
    key: "privilege_code",
  },
  {
    label: "Trial Period",
    key: "trial_period",
  },
  {
    label: "Dormant Status",
    key: "dormant_account_flag",
  },
  {
    label: "Earning Status",
    key: "mktcls_modified",
  },
  {
    label: "Momentum",
    key: "momentum_flag",
  },
  
];

